"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINTS_TARBALL_FILE_NAME = exports.ENDPOINTS_TAR_PREFIX = exports.ENDPOINTS_PACKAGE_VERSION = exports.ENDPOINTS_PACKAGE_NAME = exports.BUILD_TIME_FILENAME = exports.SDK_DEFAULT_IMPERSONATED_USER_TYPE = exports.SDK_IMPERSONATED_USER_TYPE_COOKIE_NAME = exports.SDK_KEY_COOKIE_NAME = exports.BRANCH_NAME_KEY = void 0;
exports.BRANCH_NAME_KEY = 'kh-branch-name';
exports.SDK_KEY_COOKIE_NAME = 'auroraSdkKey';
exports.SDK_IMPERSONATED_USER_TYPE_COOKIE_NAME = 'auroraSdkImpersonatedUserType';
exports.SDK_DEFAULT_IMPERSONATED_USER_TYPE = 'administrator';
exports.BUILD_TIME_FILENAME = 'build-time.txt';
exports.ENDPOINTS_PACKAGE_NAME = '@khoros/endpoints';
exports.ENDPOINTS_PACKAGE_VERSION = '1.0.0';
exports.ENDPOINTS_TAR_PREFIX = exports.ENDPOINTS_PACKAGE_NAME.slice(1).replaceAll('/', '-');
exports.ENDPOINTS_TARBALL_FILE_NAME = `${exports.ENDPOINTS_TAR_PREFIX}-${exports.ENDPOINTS_PACKAGE_VERSION}.tgz`;
//# sourceMappingURL=constants.js.map